var map = {
	"./10.jpg": 201,
	"./11.jpg": 202,
	"./12.jpg": 203,
	"./13.jpg": 204,
	"./14.jpg": 205,
	"./15.jpg": 206,
	"./16.jpg": 207,
	"./9.jpg": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;